import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import TemplateView from 'components/templates/TemplateView';
import BasePage from 'components/UI/BasePage';
import { useGetTemplatesQuery } from 'services/templates/api';
import links, { matchesLinkKey } from 'utils/links';
import { spaLinkProps } from 'utils/spaLink';

const TemplatePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { slug } = useParams<{ slug: string; }>();
  const { data: templates } = useGetTemplatesQuery();
  const template = templates && templates.find(item => matchesLinkKey(item, slug));

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{`${t('templates')}${template?.name ? ` - ${template.name}` : ''}`}</title>
      </Helmet>
      <BasePage>
        <Breadcrumb
          items={[
            { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
            { ...spaLinkProps(links.timesheet(), navigate), label: t('timesheet') },
            { label: template?.name ?? '' },
          ]}
        />
        <h4>{ template?.name }</h4>
        <br />
        {
          template && (
            <TemplateView
              template={template}
            />
          )
        }
      </BasePage>
    </>
  );
};

export default TemplatePage;
